<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box " style="width: 180px;">
					<label for="start-date"><span class="">保证金上交日期<i class="icon_select"></i></span></label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.marginPayBeginTime" type="datetime" placeholder="选择日期"
							name="start-date" class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.marginPayEndTime" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">保证金状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.marginStatus" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in waybillStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:showSummary="true" 
				:count-data="dataTotal" 
				:loading="loading" 
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
		<st-dialog title="审核意见" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">审核意见：</div>
						<div class="st-dialog-item-input"><textarea class="remarkBox" cols="30" rows="10"
								v-model="remark"></textarea></div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'

	export default {
		name: 'MarginManage',
		props: [],
		components: { stDialog },
		data() {
			return {
				dataList: [], //数据列表
				dataTotal: {},
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				bottomHandleArr: [
					{
						label: '通过审核',
						type: 'success',
						handler: () => this.marginPass()
					},
					
					{
						label: '导出',
						type: 'success',
						handler: () => this.exportTable()
					},
				],
				tableColumns: [
					{
						type: 'selection',
						fixed: 'left',
					},
					{
						title: '保证金上交日期',
						key: 'marginPayTimeFormatted'
					},
					{
						title: '司机名称',
						key: 'name',
					},
					{
						title: '订单号',
						key: 'waybillNo',
					},
					{
						title: '司机手机',
						key: 'phone',
					},
					{
						title: '金额',
						key: 'marginAmount',
					},
					{
						title: '状态',
						key: 'marginStatusDesc',
					},
					{
						title: '银行卡号',
						key: 'marginRefundCardNo',
					},
					{
						title: '开户时间',
						key: 'createTime',
					},
					{
						title: '开户银行',
						key: 'marginRefundCardType',
					},
					{
						title: '审核人',
						key: 'marginCheckName',
					}
				],
				togglePage:false,
				backPass: false,// true  通过 false者退回
				orderForm: {
					name: null,
					phone: null,
					marginPayBeginTime: null,
					marginPayEndTime: null,
					marginStatus: 0, // 0=未缴纳、1=已缴纳、2=申请退回、3=已拒绝、4=已退回
				},
				selectedList: [],// 选中的列表
				toggleStDialog: false,// 弹窗
				waybillStateList: [{
					value: 0,
					label: '未缴纳'
				}, {
					value: 1,
					label: '已缴纳'
				}, {
					value: 2,
					label: '申请退回'
				}, {
					value: 3,
					label: '已拒绝'
				}, {
					value: 4,
					label: '已退回'
				}],
				remark: null,//审核意见
			}
		},
		created() { },
		methods: {
			selectionChange(val) {
				this.selectedList = val;
			},

			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			searchList(flag) {
				this.loading = true
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.$server.financial.getWaybillCount(orderForm, (res) => {
					console.log('合计结果', res.data)
					this.dataTotal = res.data
				})
				this.$server.financial.accountPage(orderForm, (res) => {
					this.loading = false
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if(res.data.total>0){
							this.togglePage=true;
						}
					}
				})
			},
			// 通过审核
			marginPass() {
				if (this.selectedList.length < 1) {
					this.$toast.stMessage('请选择订单', true)
					return;
				}
				this.toggleStDialog = true;
				this.backPass = true;
				this.remark = null;
			},

			// 退回审核
			marginBack() {
				if (this.selectedList.length < 1) {
					this.$toast.stMessage('请选择订单', true)
					return;
				}
				this.toggleStDialog = true;
				this.backPass = false;
				this.remark = null;
			},
			saveDialogForm() {
				let data = {};
				let that = this;
				let selectedLength = this.selectedList.length - 1;
				if (this.backPass) {
					let setTime = setInterval(() => {
						data.dataId = that.selectedList[selectedLength].dataId;
						data.remark = this.remark;
						this.$server.financial.marginBackPass(data, (res) => {
							if (res.code != 0) {
								that.$toast.stMessage(res.message, false)
							} else {
								that.$toast.stMessage(`设置成功`, true)
							}
						})
						selectedLength--;
						if (selectedLength < 0) {
							clearInterval(setTime)
							that.searchList();
						}
					}, 100)
				} else {
					let setTime = setInterval(() => {
						data.accountId = that.selectedList[selectedLength].id;
						data.remark = this.remark;
						this.$server.financial.marginBackRefuse(data, (res) => {
							if (res.code != 0) {
								that.$toast.stMessage(res.message, false)
							} else {
								that.$toast.stMessage(`设置成功`, true)
							}
						})
						selectedLength--;
						if (selectedLength < 0) {
							clearInterval(setTime)
							that.searchList();
						}
					}, 100)
				}
				this.toggleStDialog = false;
			},
			// 导出
			exportTable() {
				let that = this;
				if (this.dataList.length == 0) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) => {
						return item.exportProp || item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				// sendData.marginPayBeginTime = sendData.marginPayBeginTime ? new Date(sendData.marginPayBeginTime).getTime() : ''
				// sendData.marginPayEndTime = sendData.marginPayEndTime ? new Date(sendData.marginPayEndTime).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/finance/account-page-export', sendData, (res) => {
					console.log('导出成功')
				})

			},
		},
		mounted() {

		}
	}

</script>
<style scoped>
	.margin-manage {
		width: 100%;
		height: auto;
	}

	.data-table {
		margin-bottom: 8px;
	}
	.query-setting-box{
		/* height: 108px; */
	}
	.query-setting-box-left {
		flex-grow: 0;
	}

	.order-query-form-box-right {
		margin-left: 24px;
	}

	.remarkBox {
		width: 100%;
		height: 100px;
		resize: none;
		display: block;
		margin: 1px 0;
		border: 1px solid #DCDCDC;
	}

	.st-dialog-item-input {
		margin-top: 2px;
	}

	.st-dialog-form li {
		float: none;
		width: 100%;
	}
</style>